var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cacheupdater"}},[(_vm.showVotype)?_c('button',{staticClass:"button is-primary",on:{"click":_vm.cacheUpdateVotype}},[_vm._v("刷新("+_vm._s(_vm.trueVotype)+")缓存")]):_vm._e(),(_vm.showAll)?_c('button',{staticClass:"button is-warning",on:{"click":_vm.cacheUpdateAll}},[_vm._v("刷新所有缓存")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }